import React from 'react';
import { CustomFieldDefinitionWithTargets } from 'types/customField';
import { EventCustomFieldDefinitionsContext } from './EventCustomFieldDefinitionsContext';

interface Props {
  definitions: CustomFieldDefinitionWithTargets[];
  children?: React.ReactNode;
}

export default function ManualCustomFieldDefinitionsProvider(props: Props) {
  const { definitions } = props;

  return (
    <EventCustomFieldDefinitionsContext.Provider
      value={{
        definitions,
        deleteDefinition: async () => {},
        updateDefinition: async () => {},
        createDefinition: async () => {},
      }}
      {...props}
    />
  );
}
